// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Lm8I","col":"styles_col__2lNfo"};